module.exports = __webpack_public_path__ + "static/media/double-arrow.34f14e9b.svg";